import { useQuery } from "@tanstack/react-query";

import { faxesApi } from "../apis";
import type { FaxRecord, ListFaxesParams } from "../types/fax";

export interface UseFaxesResult {
  items: FaxRecord[];
  total: number;
  isLoading: boolean;
  error: unknown;
  refetch: () => void;
}

export const useFaxes = (params: ListFaxesParams): UseFaxesResult => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [
      "faxes",
      params.practiceId,
      params.page,
      params.pageSize,
      params.fromNumber,
      params.fromDate,
      params.toDate,
    ],
    queryFn: () =>
      faxesApi.listInboundFaxes({
        // Admin must pass practiceId — BE enforces practice scope.
        practiceId: params.practiceId,
        // BE uses 1-indexed pages; UI table is 0-indexed
        page: params.page + 1,
        pageSize: params.pageSize,
        fromNumber: params.fromNumber,
        fromDate: params.fromDate,
        toDate: params.toDate,
      }),
    enabled: Boolean(params.practiceId),
  });

  return {
    items: (data?.data ?? []) as FaxRecord[],
    total: data?.pagination?.total ?? 0,
    isLoading,
    error,
    refetch,
  };
};
